export const TITULO = 'Por favor, confirme o código de segurança (CVV) do seu cartão.'

export const BOTAO_CONFIRMAR = 'Confirmar'
